import script from "./AdminAiProfilesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAiProfilesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminAiProfilesPage.vue?vue&type=style&index=0&id=400d4d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400d4d62"]])

export default __exports__